import MagicRouter from "./MagicRouter";
import Render from "./Render";
import history from "../history";

export default function RouterWrapper() {
  return (
    <MagicRouter history={history}>
      <Render />
    </MagicRouter>
  )
}
